import React from "react";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import InputAdornment from "@mui/material/InputAdornment";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SearchIcon from "@mui/icons-material/Search";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  backgroundColor: "#FFFFFF",
  cursor:"pointer",

  border: "1px solid #00000040",
  borderRadius: "4px",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));



const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "#121926",
  placeholder:"#697586",
  width: "100%",
  cursor:"pointer",
  "& .MuiInputBase-input": {
    padding: "15px 14px",
    cursor:"pointer",
    width: "100%",
    "&::placeholder": {
      color: "#697586",
      opacity: 1, // Ensures the placeholder text is fully visible
    },
    // paddingLeft: "50px",
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      "&:focus": {
        width: "100%",
      },
    },
  },
  "& .MuiInputBase-root": {
    width: "100%",
  },
}));

function DropDownInput({ handleKeyDown,open, setOpen,selectedValue }) {
  const handleToggle = (e) => {
    handleKeyDown(e)
    setOpen(!open);
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "row",
        gap: "15px",
        height: 38,
        width: "300px",
      }}
    >
      <Search style={{ width: "100%" ,cursor:"pointer"}} onClick={handleToggle}>
        <StyledInputBase
          value={selectedValue.name}
          placeholder={`Select an account`}
          inputProps={{ "aria-label": "Search Account", readOnly: true }}
          sx={{ color: "white", display: "flex" ,paddingRight:"7px"}}
          endAdornment={
            <InputAdornment position="end">
              {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </InputAdornment>
          }
        />
      </Search>
    </div>
  );
}

export default DropDownInput;
